import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';

import { getDocumentType, updateDocumentType } from '@/shared/actions/erp';
import { CustomTextField, SingleFormBoxScene } from '@/shared/components/ui';
import { newDoctypeSchema } from '@/shared/utils';

const returnUrl = '/configuracion/tipos-documentos';

export type CreateDocumentTypePageProps = {};

export type CreateFormData = {
  nombre: string;
};

export type UpdateDocumentTypePageProps = {};

const UpdateDocumentTypePage: React.FC<UpdateDocumentTypePageProps> = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  ////* form
  const form = useForm<CreateFormData>({
    resolver: yupResolver(newDoctypeSchema),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  useEffect(() => {
    (async () => {
      if (!id) return;

      const res = await getDocumentType(+id);
      reset({ nombre: res.data.nombre as any });
    })();
  }, [id]);

  const onSave = async () => {
    if (!isValid) return;
    await updateDocumentType(+id!, form.getValues());
    navigate('/configuracion/tipos-documentos');
  };

  return (
    <SingleFormBoxScene
      titlePage="Editar tipo de documento"
      onCancel={() => {
        navigate(returnUrl);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ''}
      />
    </SingleFormBoxScene>
  );
};

export default UpdateDocumentTypePage;
